import { db } from "../config/firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

// Coleção no Firestore para configuração do WhatsApp por grupo
// ⚠️ Atenção: tokens podem ficar em texto plano.
// As regras do Firestore devem restringir leitura/escrita para Admin/Gestor.
const WHATSAPP_COLLECTION = "whatsappConfig";

export const WHATSAPP_DEFAULT = {
  enabled: false,
  botEnabled: true,
  empresaIdDefault: "",

  // Credenciais (Cloud API)
  accessToken: "",
  phoneNumberId: "",
  verifyToken: "",
  appSecret: "",

  // Textos do bot (MVP)
  welcomeMessage:
    "Mamute Fit 🤖\n" +
    "Responda com:\n" +
    "1) Abrir chamado\n" +
    "2) Acompanhar status\n" +
    "3) Falar com atendente\n\n" +
    "(Dica: envie foto/vídeo do equipamento e do defeito)",

  templates: {
    confirmacaoVisita:
      "Confirma a visita para {{dataHora}} na unidade {{unidade}}?\nResponda: 1) Confirmar  2) Reagendar",
    lembreteVisita: "Lembrete: visita agendada para {{dataHora}} na unidade {{unidade}}.",
    tecnicoACaminho: "Nosso técnico está a caminho. Previsão de chegada: {{eta}}.",
    finalizado: "Atendimento finalizado ✅\nSe puder, avalie: 1 a 5.",
  },
};

function sanitizeConfig(cfg) {
  const c = cfg && typeof cfg === "object" ? cfg : {};
  const t = c.templates && typeof c.templates === "object" ? c.templates : {};

  return {
    enabled: !!c.enabled,
    botEnabled: c.botEnabled == null ? true : !!c.botEnabled,
    empresaIdDefault: String(c.empresaIdDefault || ""),
    accessToken: String(c.accessToken || ""),
    phoneNumberId: String(c.phoneNumberId || ""),
    verifyToken: String(c.verifyToken || ""),
    appSecret: String(c.appSecret || ""),
    welcomeMessage: String(c.welcomeMessage || WHATSAPP_DEFAULT.welcomeMessage),
    templates: {
      confirmacaoVisita: String(t.confirmacaoVisita || WHATSAPP_DEFAULT.templates.confirmacaoVisita),
      lembreteVisita: String(t.lembreteVisita || WHATSAPP_DEFAULT.templates.lembreteVisita),
      tecnicoACaminho: String(t.tecnicoACaminho || WHATSAPP_DEFAULT.templates.tecnicoACaminho),
      finalizado: String(t.finalizado || WHATSAPP_DEFAULT.templates.finalizado),
    },
  };
}

export async function apiGetWhatsAppConfig(grupoId) {
  if (!grupoId || typeof grupoId !== "string") throw new Error("grupoId inválido");

  const docRef = doc(db, WHATSAPP_COLLECTION, grupoId);
  const snap = await getDoc(docRef);
  if (!snap.exists()) {
    return { config: { ...WHATSAPP_DEFAULT }, updatedAt: null };
  }

  const data = snap.data() || {};
  return {
    config: sanitizeConfig(data),
    updatedAt: data?.updatedAt || null,
  };
}

export async function apiSaveWhatsAppConfig({ grupoId, config }) {
  if (!grupoId || typeof grupoId !== "string") throw new Error("grupoId inválido");

  const docRef = doc(db, WHATSAPP_COLLECTION, grupoId);
  const cfg = sanitizeConfig(config);

  await setDoc(
    docRef,
    {
      ...cfg,
      grupoId,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  return { ok: true };
}

export async function apiClearWhatsAppSecrets(grupoId) {
  if (!grupoId || typeof grupoId !== "string") throw new Error("grupoId inválido");

  const docRef = doc(db, WHATSAPP_COLLECTION, grupoId);
  await setDoc(
    docRef,
    {
      accessToken: "",
      phoneNumberId: "",
      verifyToken: "",
      appSecret: "",
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  return { ok: true };
}
